import { render, staticRenderFns } from "./changeAuthDialog.vue?vue&type=template&id=60b9cb92&scoped=true"
import script from "./changeAuthDialog.vue?vue&type=script&lang=js"
export * from "./changeAuthDialog.vue?vue&type=script&lang=js"
import style0 from "./changeAuthDialog.vue?vue&type=style&index=0&id=60b9cb92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9cb92",
  null
  
)

export default component.exports